<script>
export default {};
</script>
<style lang="scss">
@use 'variables' as vars;

span.btn span.butlink {
  padding: 0 0.5ex;
}

span.btn {
  margin: 0;
  border-radius: 20px 20px 3px 3px;
  transition-duration: 150ms;
  font-size: 80%;
  width: 80px;
  display: inline-block;
  text-align: center;
  opacity: 20%;
}
span.btn img {
  vertical-align: bottom;
}
.dark span.btn img {
  filter: invert(100%);
}
span.btn:hover {
  opacity: 90%;
  transition-duration: 300ms;
}

/* TOOLTIPS: */
.tooltip {
  position: relative;
  display: inline-block;
  z-index: 3;
}

.tooltip .tooltiptext {
  margin-top: 30px;
  margin-left: -40px;
  visibility: hidden;
  width: 120px;
  background-color: darken(vars.$background-color, 10%);
  color: vars.$front-color;
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  /* Position the tooltip */
  position: absolute;
  opacity: 0%;
  transition-duration: 300ms;
}

.dark .tooltip .tooltiptext {
  background-color: darken(vars.$background-color-dark, 10%);
  color: vars.$front-color-dark;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 100%;
  transition-delay: 1s;
  transition-duration: 300ms;
  margin-top: 50px;
}
</style>
<template>
<span class="btn tooltip">
  <div class="tooltiptext" v-html="$attrs.caption" />
  <span class="butlink" v-if="nocaption" v-html="$attrs.caption" />
  <img v-if="$attrs.icon" :src="$attrs.icon" />
</span>
</template>
